import { Injectable } from "@angular/core";
import { Apollo, QueryRef } from 'apollo-angular';
import { EnumerationInterface } from "./definitions/enumeration-interface";
import { ErrorsInterface } from "../errors/errors-interface";

export interface EnumerationResponse {
  enumeration: {
    output: EnumerationInterface;
    errors: ErrorsInterface;
  };
}

@Injectable()
export class EnumerationGetService {
  constructor(private apollo: Apollo) {}

  public getEnumerations(query: any): QueryRef<EnumerationResponse> {
    return this.apollo.watchQuery<EnumerationResponse>({
      query: query,
      fetchPolicy: "network-only",
    });
  }
}
